import { useEffect, useRef, useState } from 'react';

const useResponsiveText = <T extends Element>(initialFontSize = 16) => {
  const textRef = useRef<T | null>(null);
  const [fontSize, setFontSize] = useState(initialFontSize);

  useEffect(() => {
    const adjustFontSize = () => {
      if (!textRef.current || !textRef.current.parentElement) {
        return;
      }
      const containerWidth = textRef.current.parentElement.clientWidth;
      const textWidth = textRef.current.scrollWidth;

      const newFontSize = (containerWidth / textWidth) * fontSize;
      if (newFontSize > initialFontSize) {
        setFontSize(initialFontSize);
        return;
      }
      setFontSize(newFontSize);
    };

    adjustFontSize();
    window.addEventListener('resize', adjustFontSize);

    return () => {
      window.removeEventListener('resize', adjustFontSize);
    };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fontSize, initialFontSize, textRef.current]);

  return { fontSize, textRef };
};

export default useResponsiveText;
